import { useGeneralGetHookNoCache } from "api/hooks/allHooks";
import apiUrls from "api/urls";

import addBuildingUrls from "./urls";

export const useGetSubmittedBuildingInfoNoCache = (projectId: string | undefined, enabled = false) => {
  const url = addBuildingUrls.submittedBuildingInfo(projectId);
  return useGeneralGetHookNoCache(["submittedBuildingInfo", projectId], url, { enabled });
};

export const useGetBuildingImagesNoCache = (projectId: string | undefined) => {
  const url = apiUrls.buildingImage.list(projectId ?? "");
  return useGeneralGetHookNoCache(["buildingImages", projectId], url, { enabled: !!projectId });
};
